import axios from "axios";
import React, { useEffect, useState } from "react";
import { baseUrl, mainBaseUrl } from "../App";
import AdminDashboard from "./AdminDashboard/AdminDashboard";
import "./Styles/MainPage.scss";
import UserDashboard from "./UserDashboard";
import UserSection from "./UserSection";
import loaderimg from "../Images/InsistentTautGodwit-small.gif";
import { useHistory } from "react-router";

const MainPage = () => {
  const [certificatePool, setCertificatePool] = useState([]);
  const [rejected, setRejected] = useState([]);
  const [profile, setProfile] = useState([]);
  const [admin, setAdmin] = useState(false);
  const [ID, setID] = useState("");
  const [profileCode, setProfileCode] = useState(false);

  const history = useHistory();

  const getInfo = () => {
    var config = {
      method: "get",
      url: `${mainBaseUrl}/pool`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "API-Key": baseUrl,
      },
    };

    axios(config)
      .then(function (response) {
        setCertificatePool(response.data);
      })

      .catch(function (error) {
        if (error.response.status == 401) {
          localStorage.removeItem("token");
          history.push("/");
        }
      });
  };

  const getRejectedInfo = () => {
    var config = {
      method: "get",
      url: `${mainBaseUrl}/rejectPool`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "API-Key": baseUrl,
      },
    };

    axios(config)
      .then(function (response) {
        setRejected(response.data);
      })

      .catch(function (error) {
        if (error.response.status == 401) {
          localStorage.removeItem("token");
          history.push("/");
        }
      });
  };

  const profileInfo = () => {
    var config = {
      method: "get",
      url: `${mainBaseUrl}/users/me`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "API-Key": baseUrl,
      },
    };
    axios(config)
      .then(function (response) {
        setID(response.data.user._id);
        setProfile(response.data.user);
        setAdmin(response.data.user.admin);
        setProfileCode(false);
      })
      .catch(function (error) {
        setProfileCode(true);
        if (error.response.status == 401) {
          localStorage.removeItem("token");
          history.push("/");
        }
      });
  };

  const dummy = () => {};

  useEffect(() => {
    getInfo();
    profileInfo();
    admin ? getRejectedInfo() : dummy();
  }, []);

  if (certificatePool.length === 0) {
    return (
      <div className="imgContainer">
        <img className="gif" src={loaderimg} alt="" />
      </div>
    );
  }

  return (
    <div className="main-container">
      <UserSection
        admin={admin}
        profileInfo={profileInfo}
        ID={ID}
        profile={profile}
        getInfo={getInfo}
      />
      {admin ? (
        <AdminDashboard
          getInfo={getInfo}
          getRejectedInfo={getRejectedInfo}
          certificatePool={certificatePool}
          rejected={rejected}
          profileCode={profileCode}
          profile={profile}
        />
      ) : (
        <UserDashboard
          profile={profile}
          profileCode={profileCode}
          certificatePool={certificatePool}
        />
      )}
    </div>
  );
};

export default MainPage;
